import React from 'react';
import './style.css';

export const Table = ({ children, className }: any) => (
    <div className={`table-dsg ${className}`}>
        {children}
    </div>
);

export const THeader = ({ children, className }: any) => (
    <div className={`table-thead-dsg ${className}`}>
        {children}
    </div>
);

export const ThCell = ({ children, className }: any) => (
    <div className={`table-th-dsg ${className}`}>
        {children}
    </div>
);

export const TBody = ({ children, className }: any) => (
    <div className={`table-tbody-dsg ${className}`}>
        {children}
    </div>
);

export const TGroup = ({ children, className }: any) => (
    <div className={`table-group-dsg ${className}`}>
        {children}
    </div>
);

export const TRow = ({ children, className }: any) => (
    <div className={`table-row-dsg ${className}`}>
        {children}
    </div>
);

export const TCell = ({ children, className }: any) => (
    <div className={`table-td-dsg ${className}`}>
        {children}
    </div>
);